import React from 'react';
import './ToggleSelect.scss';

export const ToggleSelectMode = {
    ROW_DENSITY: 'ROW_DENSITY',
    ROW_STYLE: 'ROW_STYLE',
    STATUS: 'STATUS'
};

export const ToggleSelect = ({ mode, children }) => (
    <div className={'toggle-select'}>
        <span className={'select-label'}>{mode}</span>
        <div className={'toggle-select-options'}>{children}</div>
    </div>
);
